export enum ApplicationItemCodeEnum {
CA_BPEVR = "CA_BPEVR",
CA_CRA = "CA_CRA",
NMVTIS = "NMVTIS",
IL_ERT = "IL_ERT",
AUTOCHECK = "AUTOCHECK",
CARFAX = "CARFAX",
NVS = "NVS",
OPENTRACK_IMPORT = "OPENTRACK_IMPORT",
CO_MVR = "CO_MVR",
VA_EVR = "VA_EVR",
VA_MVR = "VA_MVR",
AL_MVR = "AL_MVR",
MI_MVR_VR = "MI_MVR_VR",
VA_TEMP_TAG = "VA_TEMP_TAG",
OR_EVR = "OR_EVR",
OR_MVR = "OR_MVR",
DEALERBUILT_IMPORT = "DEALERBUILT_IMPORT",
CA_ELT = "CA_ELT",
IL_MVR = "IL_MVR",
CA_SALVAGE = "CA_SALVAGE",
IL_INVENTORY = "IL_INVENTORY",
GL_EXPORT = "GL_EXPORT",
AZ_MVR = "AZ_MVR",
NATIONWIDE = "NATIONWIDE",
NATIONWIDE_DIRECT = "NATIONWIDE_DIRECT",
FL_MVR = "FL_MVR",
CA_SALVAGE_INVENTORY = "CA_SALVAGE_INVENTORY",
VA_RETAIL_INVENTORY = "VA_RETAIL_INVENTORY",
MT_ELT = "MT_ELT",
IL_GL_EXPORT = "IL_GL_EXPORT",
PBS_IMPORT = "PBS_IMPORT",
CA_FLTRNW = "CA_FLTRNW",
CA_FLTACQ = "CA_FLTACQ",
CA_FLT = "CA_FLT",
ADVENT_IMPORT = "ADVENT_IMPORT",
MT_MVR = "MT_MVR",
MT_DL_MVR = "MT_DL_MVR",
MT_MONITOR = "MT_MONITOR",
IN_REG = "IN_REG",
IN_TITLE = "IN_TITLE",
IN_MVR = "IN_MVR",
INSURANCE = "INSURANCE",
FILE_UPLOAD_IMPORT = "FILE_UPLOAD_IMPORT",
AUTOMATE_IMPORT = "AUTOMATE_IMPORT",
SHIPPING = "SHIPPING",
FLEET = "FLEET",
INTERSTATE = "INTERSTATE",
IN_TITLE_PRO_IMPORT = "IN_TITLE_PRO_IMPORT",
ACS_IMPORT = "ACS_IMPORT",
VA_GL_EXPORT = "VA_GL_EXPORT",
TX_EVR = "TX_EVR",
CA_MVR = "CA_MVR",
CA_DL = "CA_DL",
CA_OL = "CA_OL",
CA_RS_AND_TEMP_TAG = "CA_RS_AND_TEMP_TAG",
VUE_IMPORT = "VUE_IMPORT",
GRAPEVINE_IMPORT = "GRAPEVINE_IMPORT",
ADAM_IMPORT = "ADAM_IMPORT",
LIGHTSPEED_IMPORT = "LIGHTSPEED_IMPORT",
MVSC_PAYMENT = "MVSC_PAYMENT",
CDK_API_IMPORT = "CDK_API_IMPORT",
MN_EVR = "MN_EVR",
MN_MVR = "MN_MVR",
MN_INVENTORY = "MN_INVENTORY",
MIX_IMPORT = "MIX_IMPORT",
MT_TRP = "MT_TRP",
MT_DTO = "MT_DTO",
MT_RPLC = "MT_RPLC",
MD_EVR = "MD_EVR",
MD_TEMPTAG = "MD_TEMPTAG",
OOS_TITLE = "OOS_TITLE",
MD_INVENTORY = "MD_INVENTORY",
MD_MVR = "MD_MVR",
ID_EVR = "ID_EVR",
ID_MVR = "ID_MVR",
TEKION_API_IMPORT = "TEKION_API_IMPORT",
CO_EVR = "CO_EVR",
MT_FLEET = "MT_FLEET",
MT_NTX_DTO = "MT_NTX_DTO",
MT_NTX_RPLC = "MT_NTX_RPLC",
DLDV = "DLDV",
WI_EVR = "WI_EVR",
WI_MVR = "WI_MVR",
TX_MVR = "TX_MVR",
FL_EVR = "FL_EVR",
PA_EVR = "PA_EVR",
ID_NTX_EVR = "ID_NTX_EVR",
WI_INVENTORY = "WI_INVENTORY",
NTX_MVR = "NTX_MVR",
PA_MVR = "PA_MVR",
FL_INVENTORY = "FL_INVENTORY",
KY_EVR = "KY_EVR",
KY_MVR = "KY_MVR",
VUE2_IMPORT = "VUE2_IMPORT",
PA_INVENTORY = "PA_INVENTORY",
REYNOLDS_API = "REYNOLDS_API",
DX1_API_IMPORT = "DX1_API_IMPORT",
UCS_API_IMPORT = "UCS_API_IMPORT",
NTV = "NTV",
NY_MVR = "NY_MVR",
NTX_MT = "NTX_MT",
ME_MVR = "ME_MVR",
NE_MVR = "NE_MVR",
NM_MVR = "NM_MVR",
TN_MVR = "TN_MVR",
BULK_IMPORT = "BULK_IMPORT",
AR_MVR = "AR_MVR",
RI_MVR = "RI_MVR",
DE_MVR = "DE_MVR",
MI_MVR_DL = "MI_MVR_DL",
GA_RTS = "GA_RTS",
NC_RTS = "NC_RTS",
MD_RTS = "MD_RTS",
VA_RTS = "VA_RTS",
WI_RTS = "WI_RTS",
TMS = "TMS",
BATCH_MANAGER = "BATCH_MANAGER",
IL_RTS = "IL_RTS",
IN_RTS = "IN_RTS",
MA_RTS = "MA_RTS",
NJ_RTS = "NJ_RTS",
DMS_API_IMPORT = "DMS_API_IMPORT",
CA_RTS = "CA_RTS",
CT_RTS = "CT_RTS",
OH_RTS = "OH_RTS",
PA_RTS = "PA_RTS",
NY_RTS = "NY_RTS",
SC_EVR = "SC_EVR",
MA_EVR = "MA_EVR",
GA_EVR = "GA_EVR",
AT = "AT",
MT_EVR = "MT_EVR",
SC_MVR = "SC_MVR",
INSURANCE_BINDER = "INSURANCE_BINDER",
GA_MVR = "GA_MVR",
MA_INVENTORY = "MA_INVENTORY",
MA_MVR = "MA_MVR",
GA_INVENTORY = "GA_INVENTORY",
VT_MVR = "VT_MVR",
WA_MVR = "WA_MVR",
VITU_SIGN = "VITU_SIGN",
REFUND_CHECK = "REFUND_CHECK",
AK_MVR = "AK_MVR",
CT_MVR = "CT_MVR",
HI_MVR = "HI_MVR",
IA_MVR = "IA_MVR",
KS_MVR = "KS_MVR",
LA_MVR = "LA_MVR",
MS_MVR = "MS_MVR",
MO_MVR = "MO_MVR",
NV_MVR = "NV_MVR",
NH_MVR = "NH_MVR",
NJ_MVR = "NJ_MVR",
NC_MVR = "NC_MVR",
ND_MVR = "ND_MVR",
OH_MVR = "OH_MVR",
OK_MVR = "OK_MVR",
SD_MVR = "SD_MVR",
UT_MVR = "UT_MVR",
WV_MVR = "WV_MVR",
WY_MVR = "WY_MVR",
DC_MVR = "DC_MVR",
NTX_SALVAGE = "NTX_SALVAGE",
TRANSUNION_MVR = "TRANSUNION_MVR",
ADD_MVR = "ADD_MVR",
NC_EVR = "NC_EVR",
NJ_EVR = "NJ_EVR",
NJ_TEMPTAG = "NJ_TEMPTAG",
API_SETTINGS = "API_SETTINGS",
AR_EVR = "AR_EVR",
MA_GL_EXPORT = "MA_GL_EXPORT",
MI_EVR = "MI_EVR",
NC_INVENTORY = "NC_INVENTORY",
NC_TEMPTAG = "NC_TEMPTAG",
SC_INVENTORY = "SC_INVENTORY",
}
